/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/quotes, @angular-eslint/component-selector */
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { isValidEnumValue, MuiColor } from '../../utility';

@Component({
  selector: 'button[mui-legacy-fab], a[mui-legacy-fab]',
  exportAs: 'muiLegacyFab',
  template: `<i mui-icon font="fa" [name]="icon" class="mui-hero-fab__icon"></i>`,
  styleUrls: ['./mui-legacy-fab-button.component.scss']
})
export class MuiLegacyFabButton implements OnInit {
  @Input()
  @HostBinding('attr.disabled')
  set disabled(disabled: boolean | null) {
    this._disabled = disabled;
  }

  get disabled(): boolean | null {
    return this._disabled || null;
  }

  @Input() icon = 'plus';
  @Input() color: MuiColor | string = MuiColor.PRIMARY;
  @Input() class = '';

  private _disabled: boolean | null = null;

  @HostBinding('class') get buttonConfigClass(): string {
    const classes = [
      this.class, // include original classes from the DOM element
      'mui-hero-fab',
      `mui-hero-fab--${isValidEnumValue(MuiColor, this.color) ? this.color : MuiColor.PRIMARY}`
    ];

    return classes.join(' ');
  }

  ngOnInit(): void {
    if (!this.color) {
      this.color = MuiColor.PRIMARY;
    }
  }
}
